import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  card: {
    backgroundColor: theme.palette.common.white,
    boxShadow: theme.shadows[1],
    borderBottomLeftRadius: theme.shape.borderRadius,
    borderBottomRightRadius: theme.shape.borderRadius,
    transition: `box-shadow 250ms ${theme.transitions.easing.easeInOut}`,

    '&:hover': {
      boxShadow: theme.shadows[3],
    },

    '& > div': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: theme.spacing(1),
      borderTop: `1px solid ${theme.palette.grey[200]}`,
    },
  },
  cardText: {
    flex: 1,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',

    '& a': {
      color: 'inherit',
      textDecoration: 'none !important',
    },
  },
}));
